<app-breadcrumbs
	[headerTitle]="headerCrumb"
	[externalCrumbs]="externalCrumbs"
	[showAllCrumbs]="true"
	[showSideNav]="false"
	(onExternalDropDownCrumbItemSelected)="routeToMilestonePage($event)"
/>
<app-milestone-cards
	[datasource]="milestoneCardData"
	[isCPNowDeductionsEnabled]="isCPNowDeductionsEnabled"
></app-milestone-cards>
<app-net-payment-actions
	[paygroupId]="paygroupId"
	(onEmployeeSearch)="getNetPaymentOrdersBySearch($event)"
	(refreshHandler)="refreshData()"
	(goToFileHistoryHandler)="goToFileHistory()"
></app-net-payment-actions>
<app-net-payment-data
	[datasource]="paymentOrdersPagination"
	[isCPNowDeductionsEnabled]="isCPNowDeductionsEnabled"
></app-net-payment-data>
@if(paymentOrdersPagination && paymentOrdersPagination.items.length != 0){
<div class="net-order-payments-pagination flex flex-row flex-align-center-end">
	<mat-paginator
		class="pagination"
		[attr.data-test]="'net-order-payments-pagination'"
		[length]="pagination.totalPageCount"
		[pageSizeOptions]="[5, 10, 25, 100, 500]"
		[pageSize]="pagination.pageSize"
		[pageIndex]="pagination.pageIndex"
		(page)="paginate($event)"
		aria-label="Select page"
	>
	</mat-paginator>
</div>
}
